export const notionTypes = {
    START_ADD_NEW_PAGE: 'START ADD NEW PAGE',
    NEW_PAGE_ADDED: 'NEW PAGE ADDED',
    ERROR_ADDING_PAGE: 'ERROR ADDING PAGE',
    WAITING_FOR_RESPONSE: 'WAITING FOR RESPONSE',
}